<script>
  import CrmFeatureGuard from "../../..//components/feature-flags/CrmFeatureGuard.svelte";
  import MarketingModal from "../MarketingModal.svelte";
  import { forceShowProjectsMarketingModalStore } from "./stores.js";

  const handleSeeInAction = () => {
    window.location.href = "https://sourcewhale.com/projects";
  };

  const handleClose = async () => {
    $forceShowProjectsMarketingModalStore = false;
  };
</script>

<CrmFeatureGuard>
  {#snippet fallback()}
    <MarketingModal
      title="Your SourceWhale platform,<br />now complete with a CRM & ATS."
      subtitle="Projects brings every module together in one fast, recruiter-first workspace"
      previewImageSrc="/assets/img/marketing/projects-preview.svg"
      previewImageAlt="Projects interface preview"
      secondaryButtonAction={handleSeeInAction}
      onclose={handleClose}
      selectedModule="projects"
      seenKey="dismissedProjectsMarketingModal"
      forceShow={$forceShowProjectsMarketingModalStore}
    />
  {/snippet}
</CrmFeatureGuard>
